import { useState } from 'react';
import type { LeaveType } from '../types/leaveType.types';

interface LeaveTypeModalState {
  leaveType: LeaveType | null;
}

export function useLeaveTypeActionModals() {
  const [modalState, setModalState] = useState<LeaveTypeModalState | null>(null);
  const [leaveTypeToDelete, setLeaveTypeToDelete] = useState<LeaveType | null>(null);

  return {
    modalState,
    leaveTypeToDelete,
    openCreateModal: () => setModalState({ leaveType: null }),
    openEditModal: (leaveType: LeaveType) => setModalState({ leaveType }),
    closeModal: () => setModalState(null),
    openDeleteModal: setLeaveTypeToDelete,
    closeDeleteModal: () => setLeaveTypeToDelete(null),
  };
}
